import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './PaymentSecurityCard.less';
import Button, {BUTTON_STYLE} from '../../../shared-components/Button/Button';
import { UmbrellaIllustration } from './UmbrellaImage';


export const PaymentSecurityCard = ({openPaymentSecurity, removePaymentSecurity, hasPaymentSecurity}) => {
    const headerText = hasPaymentSecurity ? 'You added Payment Security' : 'Add Payment Security';
    const buttonText = hasPaymentSecurity ? 'Remove it' : 'Get the details';
    return (
        <div className="payment-security-card">
            <div className="payment-security-card-details">
                <h2 className="payment-security-card-header">{headerText}</h2>
                {!hasPaymentSecurity && 
                    <p className="payment-security-card-description">It can cover your payments or balance up to $10,000 after certain life events.</p>
                }
                <Button
                    data-automation-id="viewPaymentSecurity"
                    btnStyle={BUTTON_STYLE.LINK}
                    id="view-payment-security"
                    onClick={(event) => {
                        event.stopPropagation();
                        if (hasPaymentSecurity) {
                            return removePaymentSecurity();
                        } else {
                            return openPaymentSecurity();
                        }
                        
                    }}
                >
                    <span className="link-text change-link-text accessible-link">
                        {buttonText}
                    </span>
                    <span className="change-link-caret" />
                </Button>
            </div>
            <div className={`payment-security-card-icon ${hasPaymentSecurity ? 'addedPymtSecurity' : ''}`}>
                { hasPaymentSecurity 
                    ? <span className="hasPymtSecurityIcon ppvx_icon ppvx_icon--size_xl2 ppvx_icon-check-circle-alt" />
                    : <UmbrellaIllustration />
                }
            </div>
        </div>);
};

PaymentSecurityCard.propTypes = {
    openPaymentSecurity: PropTypes.func.isRequired,
    removePaymentSecurity: PropTypes.func.isRequired,
    hasPaymentSecurity: PropTypes.bool.isRequired,
};
